import { render, staticRenderFns } from "./customer-priorities.vue?vue&type=template&id=09e72c52&scoped=true&"
import script from "./customer-priorities.vue?vue&type=script&lang=js&"
export * from "./customer-priorities.vue?vue&type=script&lang=js&"
import style0 from "./customer-priorities.vue?vue&type=style&index=0&id=09e72c52&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e72c52",
  null
  
)

export default component.exports